<app-modal
  title="Unsaved changes">
  <ng-container body>
    <p class="body-l">You have unsaved changes in your proposal. If you leave now, your work will be lost. Would you like to save your proposals before exiting?</p>
  </ng-container>
  <ng-container footer>
    <app-button
      type="tertiary"
      size="large"
      text="Discard changes"
      (click)="closeModal()">
    </app-button>
    <app-button
      type="primary"
      size="large"
      icon="save"
      text="Save & exit"
      (click)="save()">
    </app-button>
  </ng-container>
</app-modal>
